import { assertValidVersion } from "@tsparticles/engine";
import { HslColorManager } from "./HslColorManager.js";
export async function loadHslColorPlugin(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addColorManager(new HslColorManager(), refresh);
}
